import React, { useEffect, useState } from 'react';
import TopBar from './pages/elements/topBar.jsx';
import ButtonBar from './pages/elements/buttonBar.jsx';
import ProfilePage from './pages/profile.jsx';
import ProfileUserPage from './pages/profileUser.jsx';
import ExplorePage from './pages/explore.jsx';
import SearchPage from './pages/search.jsx';
import SharePage from './pages/share.jsx';
import PlanDraftsPage from './pages/planDrafts.jsx';
import AuthModal from './pages/elements/authModal.jsx';
import SearchFilter from './pages/elements/searchFilter.jsx';
import RequestUserPage from './pages/requestUser.jsx';
import { fetchMe, logout } from './pages/elements/authApi.jsx';
import SavedPage from './pages/elements/savedPage.jsx';
import ReelViewer from './pages/elements/reelViewer.jsx';
import { getDesign } from './pages/elements/designsApi.jsx';
import { getSaved, subscribeSaved, syncSavedWithAccount } from './pages/elements/savedStore.jsx';
import ConsultantProfile from './pages/elements/consultantProfile.jsx';
import { onOpenProfile } from './pages/elements/navBus.jsx';
import { getShare, visitShare } from './pages/elements/sharesApi.jsx';
import { filterParams, activeCount } from './pages/search.jsx';

// لینکِ طرح: /d/<id>؛ لینکِ اشتراکِ هر فرستنده: /s/<code> (بازدید ثبت می‌شود و «ورود» = بازدیدِ مشترک)
const SHARE_RE = /^\/d\/([A-Za-z0-9_-]{8,24})\/?$/;
const LINK_RE = /^\/s\/([A-Za-z0-9_-]{6,16})\/?$/;

function App() {
  const [activeTab, setActiveTab] = useState('explore');
  const [isAuthModalOpen, setIsAuthModalOpen] = useState(false);
  const [isSearchFilterOpen, setIsSearchFilterOpen] = useState(false);
  // فیلترهای تبِ جست‌وجو ({ dealType, filters } از پنلِ فیلتر) — null = همه‌ی آگهی‌ها
  const [searchFilters, setSearchFilters] = useState(null);
  // اکسپلور: همان پنلِ فیلترِ جست‌وجو (جدا از تبِ جست‌وجو) + «همه‌ی طراحی‌ها / خانه‌های واقعی» کنارِ استان
  const [exploreFilters, setExploreFilters] = useState(null);
  const [filterFor, setFilterFor] = useState('search'); // پنلِ فیلتر برای کدام تب باز شده
  const [exploreKind, setExploreKind] = useState(() => {
    try {
      return localStorage.getItem('kh-explore-kind') === 'real' ? 'real' : 'all';
    } catch (e) {
      return 'all';
    }
  });
  const changeExploreKind = (k) => {
    setExploreKind(k);
    try {
      localStorage.setItem('kh-explore-kind', k);
    } catch (e) {
      /* */
    }
  };
  const [user, setUser] = useState(null);
  const [pendingTab, setPendingTab] = useState(null); // کاربر از کدوم آیکون اومده
  // استانِ نوارِ بالا — فیلترِ اکسپلور
  const [province, setProvince] = useState('تهران');
  // ذخیره‌شده‌ها (فقط روی همین گوشی)
  const [savedOpen, setSavedOpen] = useState(false);
  const [savedCount, setSavedCount] = useState(() => getSaved().length);
  useEffect(() => subscribeSaved((list) => setSavedCount(list.length)), []);
  // هر تب از بالای صفحه باز شود (جای اسکرولِ تبِ قبلی نماند — مثلاً دکمه‌ی «ساخت فایل جدید» در تبِ + زیرِ صفحه نرود)
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [activeTab]);
  // طرحی که با لینکِ اشتراک‌گذاری (/d/<id>) باز شده
  const [sharedDesign, setSharedDesign] = useState(null);
  useEffect(() => {
    const s = LINK_RE.exec(window.location.pathname);
    if (s) {
      getShare(s[1])
        .then((r) => {
          if (!r || !r.design) return;
          setSharedDesign({ ...r.design, shareCode: r.share.code });
          if (!r.share.mine) visitShare(r.share.code);
        })
        .catch(() => window.history.replaceState(null, '', '/'));
      return;
    }
    const m = SHARE_RE.exec(window.location.pathname);
    if (!m) return;
    getDesign(m[1])
      .then((r) => r && r.design && setSharedDesign(r.design))
      .catch(() => window.history.replaceState(null, '', '/'));
  }, []);
  const closeShared = () => {
    setSharedDesign(null);
    window.history.replaceState(null, '', '/');
  };

  // اگر قبلاً وارد شده (کوکیِ ورود)، کاربر را از سرور بگیر
  useEffect(() => {
    fetchMe()
      .then((u) => u && setUser(u))
      .catch(() => {});
  }, []);
  // ذخیره‌شده‌ها: با ورود، روی حساب هم نگه داشته می‌شوند
  const userId = user ? user.id : null;
  useEffect(() => {
    if (userId) syncSavedWithAccount({ id: userId });
  }, [userId]);

  // لمسِ نامِ مشاور در ریلز: اگر خودِ کاربر است → صفحه‌ی خودش؛ وگرنه پروفایلِ مشاور
  const [profileOwner, setProfileOwner] = useState(null);
  // لینکِ پروفایلِ اشتراک‌گذاشته‌شده (/p/<id>): همان پروفایلِ مشاور باز می‌شود
  useEffect(() => {
    const pm = /^\/p\/(\d{1,12})\/?$/.exec(window.location.pathname);
    if (pm) setProfileOwner({ id: Number(pm[1]), firstName: '', lastName: '', phone: null });
  }, []);
  const closeProfileOwner = () => {
    setProfileOwner(null);
    if (window.location.pathname.startsWith('/p/')) window.history.replaceState(null, '', '/');
  };
  const userRef = React.useRef(user);
  userRef.current = user;
  useEffect(
    () =>
      onOpenProfile((owner) => {
        const me = userRef.current;
        if (me && me.id === owner.id) {
          setSavedOpen(false);
          setSharedDesign(null);
          setProfileOwner(null);
          if (window.location.pathname !== '/') window.history.replaceState(null, '', '/');
          setActiveTab('profile');
          return;
        }
        setProfileOwner(owner);
      }),
    []
  );

  const handleLogout = async () => {
    try {
      await logout();
    } catch (e) {
      /* حتی اگر سرور جواب نداد، در برنامه خارج شو */
    }
    setUser(null);
    syncSavedWithAccount(null);
    setActiveTab('explore');
  };

  const handleNavSelect = (id) => {
    if ((id === 'profile' || id === 'add') && !user) {
      setPendingTab(id); // یادآوری مقصد اصلی
      setIsAuthModalOpen(true);
      return;
    }
    setActiveTab(id);
  };

  const handleAuthSuccess = (userData) => {
    setUser(userData);
    setIsAuthModalOpen(false);
    setActiveTab(pendingTab ?? 'profile'); // برگشت به همون آیکونی که ازش اومده
    setPendingTab(null);
  };

  const handleAuthClose = () => {
    setIsAuthModalOpen(false);
    setPendingTab(null); // اگه لغو کرد، چیزی رو هدایت نکن
  };

  const openFilter = (tab) => {
    setFilterFor(tab);
    setIsSearchFilterOpen(true);
  };
  const handleFilterClick = () => openFilter(activeTab === 'explore' ? 'explore' : 'search');

  return (
    <div className="app">
      {activeTab !== 'profile' && (
        <TopBar
          province={province}
          onProvinceChange={setProvince}
          onFilterClick={handleFilterClick}
          onSavedClick={() => setSavedOpen(true)}
          savedCount={savedCount}
          kind={exploreKind}
          onKindChange={activeTab === 'explore' ? changeExploreKind : undefined}
          filterCount={activeCount(filterParams(activeTab === 'explore' ? exploreFilters : activeTab === 'search' ? searchFilters : null))}
        />
      )}

      {activeTab === 'profile' && user?.role === 'consultant' && <ProfilePage user={user} onLogout={handleLogout} onUserUpdate={setUser} />}
      {activeTab === 'profile' && user?.role === 'client' && <ProfileUserPage user={user} onLogout={handleLogout} onUserUpdate={setUser} />}
      {activeTab === 'add' && user?.role === 'client' && <RequestUserPage />}

      {activeTab === 'explore' && (
        <div style={{ paddingTop: 52 }}>
          <ExplorePage
            province={province}
            kind={exploreKind}
            applied={exploreFilters}
            onOpenFilter={() => openFilter('explore')}
            onClearFilter={() => setExploreFilters(null)}
          />
        </div>
      )}

      {activeTab === 'search' && (
        <SearchPage
          province={province}
          applied={searchFilters}
          onOpenFilter={() => openFilter('search')}
          onClearFilter={() => setSearchFilters(null)}
        />
      )}
      {activeTab === 'share' && <SharePage />}

      {activeTab === 'add' && user?.role === 'consultant' && <PlanDraftsPage />}
      {activeTab === 'add' && user?.role === 'client' && (
        <div style={{ paddingTop: 52, padding: '52px 16px 0' }}>
          <p>صفحه requestUser.jsx — قدم بعدی</p>
        </div>
      )}

      <ButtonBar activeId={activeTab} onSelect={handleNavSelect} />

      {savedOpen && <SavedPage onClose={() => setSavedOpen(false)} />}
      {sharedDesign && <ReelViewer items={[sharedDesign]} startIndex={0} onClose={closeShared} history={false} />}
      {profileOwner && <ConsultantProfile key={profileOwner.id} owner={profileOwner} onClose={closeProfileOwner} />}

      {isAuthModalOpen && (
        <AuthModal onClose={handleAuthClose} onSuccess={handleAuthSuccess} />
      )}

      {isSearchFilterOpen && (
        <SearchFilter
          onClose={() => setIsSearchFilterOpen(false)}
          initial={filterFor === 'explore' ? exploreFilters : searchFilters}
          onApply={(applied) => {
            if (filterFor === 'explore') setExploreFilters(applied);
            else setSearchFilters(applied);
            setIsSearchFilterOpen(false);
          }}
        />
      )}
    </div>
  );
}

export default App;